import React from 'react';

export const Required = () => {
	return <span className="tw-text-[#008b6d] tw-font-bold">*</span>;
};

Required.displayName = 'Required';
